<template>
    <div class="u-margin-bottom">
        <div class="layout" v-if="customer.customer_number">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.customer_number') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.customer_number }}
            </div>
        </div>
        <div class="layout" v-if="customer.organization">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.organization') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.organization }}
            </div>
        </div>
        <div class="layout" v-if="customer.phone">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.phone') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.phone }}
            </div>
        </div>
        <div class="layout" v-if="customer.coc_number">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.coc_number') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.coc_number }}
            </div>
        </div>
        <div class="layout" v-if="customer.vat_number">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.vat_number') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.vat_number }}
            </div>
        </div>
        <div class="layout" v-if="customer.purchase_reference">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.purchase_reference') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.purchase_reference }}
            </div>
        </div>
        <div class="layout" v-if="customer.terms_of_payment">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.terms_of_payment') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.terms_of_payment }}
            </div>
        </div>
        <div class="layout" v-if="customer.credit_limit">
            <div class="layout__item u-1/4-desk">
                <span class="page-block__item-content-title">
                    {{ trans('profile.credit_limit') }}
                </span>
            </div>
            <!--
         -->
            <div class="layout__item u-3/4-desk">
                {{ customer.credit_limit | toEuro }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProfileCustomerGeneral',
    props: {
        customer: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
